module.exports = __webpack_public_path__ + "media/img/android-icon-72x72-2e754bf97911d4e4db56845cc8b73bc8.png";